import SudokuGrid from '../components/sudoku/SudokuGrid';
import {
  getGivenMask,
  getHint,
  normalizeSudokuGrid,
  validateSudoku,
} from '../components/sudoku/SudokuValidator';

const sudokuAdapter = {
  slug: 'sudoku',

  normalizeState(initialState) {
    return normalizeSudokuGrid(initialState);
  },

  getGivenMask(initialState) {
    return getGivenMask(initialState);
  },

  check(state) {
    return validateSudoku(state);
  },

  getHint(state) {
    return getHint(state);
  },

  renderBoard({
    state,
    givenMask,
    onCellSelect,
    errorCells,
    hintCells,
    selectedCell,
    selectedValue,
    notes,
  }) {
    return (
      <div className="flex justify-center">
        <SudokuGrid
          grid={state}
          givenMask={givenMask}
          onCellSelect={onCellSelect}
          errorCells={errorCells}
          hintCells={hintCells}
          selectedCell={selectedCell}
          selectedValue={selectedValue}
          notes={notes}
        />
      </div>
    );
  },
};

export default sudokuAdapter;
